import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OnboardingService } from '../services/onboarding.service';
 

@Injectable({ providedIn: 'root' })
export class PrimaAutenticazioneGuard implements CanActivate {
  constructor(private onboarding: OnboardingService, private router: Router) {}
  async canActivate(): Promise<boolean> {
    const ctx = await this.onboarding.getOnboardingContext();
    if (!ctx) {
      this.router.navigateByUrl('/primo-accesso');
      return false;
    }
    return true;
    }
}
